/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { Container, injectable } from 'inversify';
import { vappContainer } from './index';
import { EventBusModule } from '@common/event-bus-module';
import { JwtModule } from '@common/jwt-module';

export class UnitTest {
  constructor() {}

  async run() {
    // await this.eventBusTest();
    await this.jwtTest();
  }

  async eventBusTest() {
    //------------->>>>>--------------//
    const ebModule = vappContainer.get<EventBusModule>(
      EventBusModule.displayName
    );
    const eb = ebModule?.getEventBus();
    eb.on('test-event', function (payload: any) {
      console.log('event received', payload);
    });
    eb.emit('test-event', null, {
      message: 'Hello From vlinder unit test',
    });
    //------------->>>>>--------------//
  }

  async jwtTest() {
    const jwtModule = vappContainer.get<JwtModule>(JwtModule.displayName);
    const token =
      'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNoYXJtYXBvb2phOTc4M0BnbWFpbC5jb20iLCJ2dWlkIjoiOTc1MDk2OTU4OTU4IiwiY3VycmVudFJvbGUiOnsibmFtZSI6InB1cmNoYXNlciIsInV1aWQiOiJkZTNjNzkxMi0zYTUyLTQxYzgtOWEzNC1iYzBmMDU4ZjQwOTciLCJhdXRoVHlwZSI6IlBBU1NXT1JEIn0sImlhdCI6MTY4NzI4NzIyOSwiZXhwIjoxNjg3NDYwMDI5LCJhdWQiOiJib2lsZXJwbGF0ZS52bGluZGVyLmlvIiwiaXNzIjoidmxpbmRlciIsInN1YiI6Ijk3NTA5Njk1ODk1OCIsImp0aSI6IjdmMmUwNzEwLTYzMjktNDVmNi04ZGZmLTgwYTBjMDhjNmQ5NSJ9.QrNPufB6q1GgmYBsrp2wT4brcYsn-CdJXuePFRE4wkK7nPIT2CrL0g9E6Q41N_Is99zM176VKzgtmHQeinyJfQOWIrdSWEtAZlMtiPpEOaBXJT4O-2hTRBhItB1QnBsBHMCshZwBSZqpImSU_WpRHQh4LDmKMVcoKpjZHgnhjWk';
    const result = jwtModule.verify(token);
    console.log('result ->', result);
  }

  async dummyGraphQlQuery() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
  }
}
